import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class CricketHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="cricket"
      title="Cricket Scorecards & Ball-by-Ball Updates"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Cricket/containers/CricketHomePage.js